module.exports = {
  METRICS: 'metrics',
  TAGS: 'tags',
  DEVICE_INFO_METRICS: 'deviceInfoMetrics',
  CONNECTION_INFO_METRICS: 'connectionInfoMetrics',
  BROWSER_INFO_METRICS: 'browserInfoMetrics',
};
